<template>
  <div>
    <p class="title">Opisy not księgowych</p>
    <div
      v-for="(
        accountingNoteDescription, index
      ) in sortedAccountingNoteDescriptions"
      :key="accountingNoteDescription.id"
    >
      <div class="description-container">
        <div class="order-box">
          <p class="font-header">Kolejność</p>
          <select
            @change="
              handleDescriptionOrderNumber($event, accountingNoteDescription.id)
            "
          >
            <option
              :selected="index === orderNumber - 1"
              v-for="orderNumber in orderNumbers"
              :key="orderNumber"
              :value="orderNumber - 1"
            >
              {{ orderNumber }}
            </option>
          </select>
        </div>
        <div class="name-box">
          <p class="font-header">Nazwa</p>
          <input
            type="text"
            class="w-100"
            v-model="accountingNoteDescription.name"
          />
        </div>
        <div class="delete-button">
          <CustomButton
            size="small"
            title="Usuń"
            :pink="true"
            style="height: 35px"
            @click="deleteAccountingNote(accountingNoteDescription.id)"
          />
        </div>
      </div>
      <div class="description">
        <textarea
          v-model="accountingNoteDescription.description"
          maxlength="100"
        />
      </div>
    </div>
    <p class="add-new-description" @click="addNewDescriptionBox">
      + Dodaj nowe pole
    </p>
    <div class="p-0 flex btns-wrapper">
      <custom-button size="large" title="Zapisz" @click="saveChanges" />
    </div>
  </div>
</template>


<script>
import axios from "../../axios";
import CustomButton from "../../components/CustomButton.vue";
export default {
  name: "AccountingNotesDescriptions",
  components: {
    CustomButton,
  },
  data() {
    return {
      accountingNoteDescriptions: [],
      newAccountingNoteDescriptions: [],
      deletedAccountingNoteDescriptions: [],
    };
  },
  methods: {
    handleDescriptionOrderNumber(event, id) {
      const newOrder = parseInt(event.target.value);
      const existingDescription = this.accountingNoteDescriptions.find(
        (description) => description.id === id
      );

      const newDescription = this.newAccountingNoteDescriptions.find(
        (description) => description.id === id
      );

      if (existingDescription) {
        existingDescription.orderNumber = newOrder;
      }
      if (newDescription) {
        newDescription.orderNumber = newOrder;
      }

      const descriptionWithOrderNumber = [
        ...this.accountingNoteDescriptions,
        ...this.newAccountingNoteDescriptions,
      ].find(
        (description) =>
          description.orderNumber === newOrder &&
          description.id !== id &&
          description.orderNumber >= newOrder
      );
      if (descriptionWithOrderNumber) {
        descriptionWithOrderNumber.orderNumber = newOrder + 1;
      }
    },

    async saveChanges() {
      for await (const description of this.newAccountingNoteDescriptions) {
        await axios.post("/api/accountingNoteDescriptions", {
          name: description.name,
          description: description.description,
          orderNumber: description.orderNumber,
        });
      }
      for await (const id of this.deletedAccountingNoteDescriptions) {
        await axios.delete(`/api/accountingNoteDescriptions/${id}`);
      }
      for await (const description of this.accountingNoteDescriptions) {
        await axios.put(`/api/accountingNoteDescriptions/${description.id}`, {
          name: description.name,
          description: description.description,
          orderNumber: description.orderNumber,
        });
      }
      const sortedByOrderNumber = [...this.accountingNoteDescriptions].sort(
        (a, b) => a.orderNumber - b.orderNumber
      );

      await axios.post(`/api/accountingNoteDescriptions/updateOrder`, {
        ids: sortedByOrderNumber.map((description) => description.id),
      });

      this.deletedAccountingNoteDescriptions = [];
      this.newAccountingNoteDescriptions = [];
      const descriptionsResponse = await axios.get(
        "/api/accountingNoteDescriptions"
      );
      this.accountingNoteDescriptions = descriptionsResponse.data;

      this.$notify({
        text: "Pomyślnie zapisano zmiany",
        group: "success",
      });
    },

    addNewDescriptionBox() {
      this.newAccountingNoteDescriptions.push({
        id: Math.random(),
        name: "",
        description: "",
        orderNumber:
          this.accountingNoteDescriptions.length +
          this.newAccountingNoteDescriptions.length +
          1,
      });
    },
    async deleteAccountingNote(id) {
      if (
        this.accountingNoteDescriptions.find(
          (description) => description.id === id
        )
      ) {
        this.deletedAccountingNoteDescriptions.push(id);
      }
      this.accountingNoteDescriptions = [
        ...this.accountingNoteDescriptions,
      ].filter((description) => description.id !== id);
      this.newAccountingNoteDescriptions = [
        ...this.newAccountingNoteDescriptions,
      ].filter((description) => description.id !== id);
    },
  },

  async mounted() {
    const descriptionsResponse = await axios.get(
      "/api/accountingNoteDescriptions"
    );
    this.accountingNoteDescriptions = descriptionsResponse.data;
  },
  computed: {
    orderNumbers() {
      const numbers = [];
      for (
        let i = 0;
        i <
        this.accountingNoteDescriptions.length +
          this.newAccountingNoteDescriptions.length;
        i++
      ) {
        numbers.push(i + 1);
      }
      return numbers;
    },

    sortedAccountingNoteDescriptions() {
      return [
        ...this.accountingNoteDescriptions,
        ...this.newAccountingNoteDescriptions,
      ].sort((a, b) => a.orderNumber - b.orderNumber);
    },
  },
};
</script>

<style scoped>
.title {
  color: var(--rowy-100, #e2037e);
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 1.5rem;
}
.description-container {
  display: flex;
  align-items: flex-end;
  gap: 2rem;
}
.name-box {
  width: 85%;
}
input,
select {
  height: 35px;
  color: var(--granatowy-100, #090741);
  /* web/body/tekst regular 1 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
textarea {
  padding: 10px;
  height: 100px;
  color: rgba(9, 7, 65, 0.75);

  /* web/body/tekst regular 1 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
select {
  width: 70px;
  text-align: center;
  padding: 0 10px;
}
.font-header {
  color: rgba(9, 7, 65, 0.75);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}
textarea {
  width: 100%;
}
.add-new-description {
  color: #e2037e;

  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 1.5rem;
  cursor: pointer;
  width: fit-content;
}
.btns-wrapper {
  justify-content: center;
  align-items: center;
  gap: 20px;
}
</style>